// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1QPT2","header":"ClearentDisclaimer_header__2ITOB","inner":"ClearentDisclaimer_inner__1niZi"};